import Vue from 'vue'
import VueRouter from 'vue-router'
import { Role } from '@/auth/role'
import store from '@/store.js'

Vue.use(VueRouter)

let router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'login',
            component: () => import('@/views/Login.vue')
        },
        {
            path: '/policy',
            name: 'policy',
            component: () => import('@/views/Policy.vue')
        },
        {
            path: '/mobile/instruction',
            name: 'instruction',
            component: () => import('@/views/MobileRegisterInstruction.vue')
        },
        {
            path: '/no-nb/mobile/instruction',
            name: 'instruction',
            component: () => import('@/views/MobileRegisterInstructionNorsk.vue')
        },
        {
            path: '/account/delete',
            name: 'deleteAccount',
            component: () => import('@/views/Users/DeleteUserForm.vue')
        },
        {
            path: '/main',
            name: 'main',
            component: () => import('@/views/Main.vue'),
            meta: {
                requiresAuth: true,
                authorize: [Role.Admin, Role.Service, Role.User]
            },
            children: [
                {
                    path: '/alarms',
                    name: 'alarms',
                    component: () => import('@/views/Alarms'),
                    props: true,
                    meta: { authorize: [Role.Admin, Role.Service] }
                },
                {
                    path: '/visits',
                    name: 'visits',
                    component: () => import('@/views/VisitsView'),
                    meta: { autorize: [Role.Admin, Role.Service] },
                    children: [
                        {
                            path: '/visits/list',
                            name: 'visitsList',
                            component: () => import('@/views/Visits/Visits'),
                            default: true
                        },
                        {
                            path: '/visits/problems',
                            name: 'visitsProblems',
                            component: () => import('@/views/Visits/Problems'),
                            props: true
                        },
                        {
                            path: '/visits/solutions/:visitId',
                            name: 'visitsSolutionsForVisit',
                            component: () => import('@/views/Visits/Solutions'),
                            props: true
                        },
                        {
                          path: '/visits/solutions/:problemId',
                          name: 'solutionsForProblem',
                          component: () => import('@/views/Visits/Solutions'),
                          props: true,
                        },
                        {
                          path: '/visits/solutions/:visitId',
                          name: 'visitsSolutionsForVisit',
                          component: () => import('@/views/Visits/Solutions'),
                          props: true
                        },
                        {
                            path: '/visits/solutions',
                            name: 'visitsSolutions',
                            component: () => import('@/views/Visits/Solutions'),
                            props: true
                        },
                    ]
                },
                {
                    path: '/systems',
                    name: 'systems',
                    component: () => import('@/views/Systems'),
                    meta: { authorize: [Role.Admin, Role.Service, Role.User] }
                },
                {
                    path: '/systems/map',
                    name: 'map',
                    component: () => import('@/views/MapBoxView'),
                    meta: { authorize: [Role.Admin, Role.Service, Role.User] }
                },
                {
                    path: '/systems/weights',
                    name: 'weights',
                    component: () => import('@/views/HerdsWeightView'),
                    meta: { authorize: [Role.Admin, Role.Service, Role.User] }
                },
                {
                    path: '/systems/dashboard',
                    name: 'dashboard',
                    component: () => import('@/views/Dashboard'),
                    meta: { authorize: [Role.Admin, Role.Service, Role.User] }
                },
                {
                    path: '/users',
                    name: 'users',
                    component: () => import('@/views/Users/Users'),
                    meta: { authorize: [Role.Admin] },
                },
                {
                    path: '/users/contacts',
                    name: 'contacts',
                    component: () => import('@/views/Contacts'),
                    meta: { authorize: [Role.Admin, Role.Service] }
                },
                {
                    path: '/users/invitations',
                    name: 'invitations',
                    component: () => import('@/views/Users/UsersInvitations'),
                    meta: { authorize: [Role.Admin] },
                },
                {
                    path: '/faq',
                    name: 'faq',
                    component: () => import('@/views/Faq'),
                    meta: { authorize: [Role.Admin, Role.Service, Role.User] }
                },
                {
                    path: '/devices/:systemName/:systemId',
                    name: 'devices',
                    props: true,
                    component: () => import('@/views/Devices'),
                    meta: { authorize: [Role.Admin, Role.Service, Role.User] }
                },
                {
                    path : '/contactForm/:farmName/:farmId',
                    name: 'contactForm',
                    props: true,
                    component: () => import('@/views/ContactForm'),
                    meta: { authorize: [Role.Admin, Role.Service] }
                },
                {
                    path: '/systemState/:systemName/:systemId',
                    name: 'systemState',
                    props: true,
                    component: () => import('@/views/SystemState'),
                    meta: { authorize: [Role.Admin, Role.Service, Role.User] },
                    children: [
                        {
                          default: true,
                          path: '/systemState/:systemName/:systemId/general',
                          name: 'settingsGeneral',
                          component: () => import('@/views/System/SettingsGeneral.vue'),
                          props: true,
                          meta: { authorize: [Role.Admin, Role.Service, Role.User] },
                        },
                        {
                          path: '/systemState/:systemName/:systemId/devices',
                          name: 'settingsDevices',
                          component: () => import('@/views/System/SettingsDevices.vue'),
                          props: true,
                        },
                        {
                          path: '/systemState/:systemName/:systemId/alarms',
                          name: 'settingsAlarms',
                          component: () => import('@/views/System/SettingsAlarms.vue'),
                          props: true,
                        },
                        {
                          path: '/systemState/:systemName/:systemId/roughage',
                          name: 'settingsRoughage',
                          component: () => import('@/views/System/SettingsRoughage.vue'),
                          props: true,
                        },
                        {
                          path: '/systemState/:systemName/:systemId/sorting',
                          name: 'settingsSorting',
                          component: () => import('@/views/System/SettingsSorting.vue'),
                          props: true,
                        },
                        {
                          path: '/systemState/:systemName/:systemId/statistics',
                          name: 'settingsStatistics',
                          component: () => import('@/views/System/SettingsStatistics.vue'),
                          props: true,
                        },
                        {
                            path: '/systemState/:systemName/:systemId/visits',
                            name: 'systemVisits',
                            component: () => import('@/views/Visits/Visits'),
                            props: true
                        },
                        {
                          path: '/systemState/:systemName/:systemId/problems',
                          name: 'settingsProblems',
                          component: () => import('@/views/Visits/Problems'),
                          props: true,
                        },
                        {
                          path: '/systemState/:systemName/:systemId/problems/:visitId',
                          name: 'settingsProblemsVisit',
                          component: () => import('@/views/Visits/Problems'),
                          props: true,
                        },
                        {
                            path: '/systemState/:systemName/:systemId/solutions/:problemId',
                            name: 'settingsProblemSolutionsHistory',
                            component: () => import('@/views/Visits/Solutions'),
                            props: true,
                          },
                        {
                            path: '/systemState/:systemName/:systemId/solutions/:visitId',
                            name: 'systemSolutionsForVisit',
                            component: () => import('@/views/Visits/Solutions'),
                            props: true
                        },
                        // {
                        //   path: '/systemState/:systemName/:systemId/tickets',
                        //   name: 'settingsTickets',
                        //   component: Tickets,
                        //   props: true,
                        // },
                        {
                            path: '/systemState/:systemName/:systemId/generalAlarms',
                            name: 'systemsGeneralAlarms',
                            component: () => import('@/views/System/SystemGeneralAlarms'),
                            props: true
                        },
                        {
                            path: '/systemState/:systemName/:systemId/todo',
                            name: 'systemsTasks',
                            component: () => import('@/views/System/SystemTasks'),
                            props: true
                        },
                        {
                            path: '/systemState/:systemName/:systemId/settings',
                            name: 'systemSettings',
                            component: () => import('@/views/System/SystemSettings.vue'),
                            props: true
                        },
                        {
                            path: '/systemState/:systemName/:systemId/tickets',
                            name: 'systemTickets',
                            component: () => import('@/views/System/SystemFarmerTickets'),
                            props: true
                        },
                        {
                            path: '/systemState/:systemName/:systemId/animals',
                            name: 'systemAnimals',
                            component: () => import('@/views/System/SystemAnimals'),
                            props: true
                        },
                        {
                            path: '/systemState/:systemName/:systemId/notifications',
                            name: 'systemNotifications',
                            component: () => import('@/views/System/SystemNotifications'),
                            props: true
                        },
                    ]
                },
                {
                    path: 'cloud',
                    name: 'cloud',
                    component: () => import('@/views/BackupCloud.vue'),
                    meta: { authorize: [Role.Admin] }
                },
                {
                    path: 'softwareMain',
                    name: 'softwareMain',
                    component: () => import('@/views/Software/SoftwareMain.vue'),
                    meta: { authorize: [Role.Admin]}
                },
                {
                    path: 'software',
                    name: 'software',
                    component: () => import('@/views/Software/SoftwareShortcuts.vue'),
                    meta: { authorize: [Role.Admin] }
                },
                {
                    path: 'softwareManagement',
                    name: 'softwareManagement',
                    component: () => import('@/views/Software/SoftwareManagement.vue'),
                    meta: { authorize: [Role.Admin] }
                },
                {
                    path: 'softwareRequirements',
                    name: 'softwareRequirements',
                    component: () => import('@/views/Software/SoftwareRequirements.vue'),
                    meta: { authorize: [Role.Admin] }
                },
                {
                    path: 'backups',
                    name: 'backups',
                    component: () => import('@/views/BackupManagement.vue'),
                    meta: { authorize: [Role.Admin] }
                },
                {
                    path: 'scheduledReports',
                    name: 'scheduledReports',
                    component: () => import('@/views/ScheduledReports.vue'),
                    meta: { authorize: [Role.Admin] }
                },
                {
                    path: 'apiUsage',
                    name: 'apiUsage',
                    component: () => import('@/views/ApiUsage.vue'),
                    meta: { authorize: [Role.Admin] }
                }
            ]
        },
    ]
})

router.beforeEach(async (to, from, next) => {
    const { authorize } = to.meta;

    if(to.params.systemNameFilter != null) {
        await store.dispatch('change_filter', to.params.systemNameFilter);
    } else {
        await store.dispatch('change_filter', '');
    }

    if (authorize) {
        if (!store.getters.isLoggedIn) {
            return next({ path: '/'});
        }

        if (authorize.length && !authorize.some(r=> store.getters.user.roles.indexOf(r) >= 0)) {
            return next({ path: '/' });
        }
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js